import { defineComponent as _defineComponent } from 'vue'


// props
interface Props {
  err?: Error;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorCard',
  props: {
    err: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})